import gaTracker from "./ga-tracker";

var fields = [
    "first_name",
    "last_name",
    "company",
    "address_1",
    "address_2",
    "city",
    "state",
    "postcode",
    "phone",
    "email"
  ],
  billingLabel = "#billing_",
  shippingLabel = "#shipping_";

function init() {
  const checkbox = document.querySelector(".js-ship-to-billing-address");

  if (checkbox) {
    checkbox.addEventListener("click", function (event) {
      if (checkbox.checked) {
        setShippingFields();
      } else {
        clearShippingFields();
      }
    });
  }
}

function setShippingFields() {
  for (var i = 0; i < fields.length; i++) {
    var billingValue = $(billingLabel + fields[i]).val();
    $(shippingLabel + fields[i]).val(billingValue);
  }

  gaTracker.trackEcomm("checkoutOption|1|Ship to Billing Address");
}

function clearShippingFields() {
  for (var i = 0; i < fields.length; i++) {
    $(shippingLabel + fields[i]).val("");
  }

  gaTracker.trackEcomm("checkoutOption|1|Ship to Different Address");
}

export default {
  init
};
